"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function Overview() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="overview" data-nav="light" className="bg-background py-14 md:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="mx-auto max-w-3xl text-center">
          <h2 className="font-default text-2xl sm:text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Temporary Refrigerated Storage for Commercial Needs
          </h2>
          <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">
            A 53-foot reefer trailer can provide temporary refrigerated storage for businesses, facilities, distributors, events, planned projects, and unexpected storage needs. Contact Fridge Fleet to discuss your location, rental dates, intended use, and temperature requirements.
          </p>
        </motion.div>
      </div>
    </section>;
}